import React, { useState } from "react";
import PropTypes from "prop-types";
import Plot from "react-plotly.js";
import { Button, Modal } from "antd";

export const LCFPlot = ({ data, active }) => {
  const [showInfo, setInfoModal] = useState(false);

  const InfoModal = (
    <Modal
      title="Local Color Fidelity"
      visible={showInfo}
      onCancel={() => setInfoModal(false)}
      footer={[
        <Button key="close" onClick={() => setInfoModal(false)}>
          Close
        </Button>,
      ]}
    >
      Local Color Fidelity is the average magnitude of color difference for the
      color samples in each hue-angle bin. Values closer to 100 indicate greater
      similarity to the reference. The colors of the bars are for visual
      orientation only.
    </Modal>
  );

  const x = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
  let y = [];
  let y_rounded = [];
  data.map((value) => y.push(value));
  for (let i = 0; i < 16; i++) {
    y_rounded[i] = `${Math.round(y && y[i])}`;
  }
  /**
   * Colors for each bar/Huebin. Used throughout the code.
   */
  const bar_colors = [
    "#b45c60",
    "#cb7761",
    "#cb824b",
    "#d7ad67",
    "#ac9a5d",
    "#919E60",
    "#678B5F",
    "#62B08F",
    "#7CBABA",
    "#2C797D",
    "#54778C",
    "#7189B1",
    "#988CA9",
    "#735876",
    "#8F6682",
    "#B97B8E",
  ];

  return (
    <div>
      <Plot
        useResizeHandler={true}
        style={{ paddingLeft: "6px" }}
        title={null}
        data={[
          {
            name: "",
            type: "bar",
            x: x,
            y: y,
            marker: {
              color: bar_colors,
            },
            textfont: {
              size: 14,
            },
            text: y_rounded,
            textposition: "outside",
            hovertemplate: `<i>R</i><sub>f,h%{x}</sub>: %{text}`,
          },
        ]}
        layout={{
          width: 500,
          height: 250,
          margin: {
            l: 64,
            r: 8,
            b: 45,
            t: 2,
            pad: 0,
          },
          xaxis: {
            title: {
              text: "Hue-Angle Bin (<i>j</i>)",
              font: {
                size: 15,
              },
            },
            tickmode: "linear",
            fixedrange: true,
            mirror: "ticks",
            linewidth: 2,
            linecolor: "black",
          },
          yaxis: {
            showline: true,
            range: [0, 115],
            title: {
              text: "Local Color Fidelity (<i>R</i><sub>f,h<i>j</i></sub>)",
              font: {
                size: 15,
              },
            },
            tickformat: "",
            fixedrange: true,
            // ticklen: 6,
            // tickwidth: 2,
            mirror: "ticks",
            linewidth: 2,
            linecolor: "black",
          },
          bargap: active === "Full" ? 2 : 5,
        }}
        config={{
          displaylogo: false,
          modeBarButtons: [
            [
              "toImage",
              {
                name: "Info",
                icon: "",
                click: () => setInfoModal(true),
              },
            ],
          ],
          responsive: true,
          toImageButtonOptions: {
            format: "png", // one of png, svg, jpeg, webp
            filename: "Local Color Fidelity",
            height: 250,
            width: 500,
            scale: 1.5, // Multiply title/legend/axis/canvas sizes by this factor
          },
        }}
      />
      {InfoModal}
    </div>
  );
};

LCFPlot.propTypes = {
  data: PropTypes.array,
  active: PropTypes.string,
};
